import React from "react";
import Chart from "react-apexcharts";

const LineGraph = (props) => {
  const labels = props.LineGraphLabel.concat([""]);
  const series = props.LineGraphSeries.concat([
    props.LineGraphSeries[props.LineGraphSeries.length - 1],
  ]);

  const temp = {
    series: [
      {
        data: series,
      },
    ],
    options: {
      chart: {
        type: "line",
        height: 450,
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
        toolbar: {
          show: false,
        },
        labels: {
          style: {
            color: "#fff",
          },
        },
        zoom: {
          enabled: false,
        },
      },
      annotations: {
        position: "back",
        yaxis: [
          {
            label: {
              text: "",
            },
            y: 0,
            y2: 2,
            fillColor: "#FBCEB1",
          },
          {
            label: {
              text: "",
            },
            y: 2,
            y2: 3,
            fillColor: "#8D139F",
          },
          {
            label: {
              text: "",
            },
            y: 3,
            y2: 4,
            fillColor: "#FFD700",
          },
        ],
      },
      stroke: {
        width: 5,
        curve: "smooth",
      },
      title: {
        text: "Subject - Wise Performance",
        align: "center",
        style: {
          color: "#fff",
          fontSize: 20,
        },
      },
      xaxis: {
        type: "category",
        categories: labels,
        labels: {
          formatter: function (value) {
            if (typeof value == "string") {
              const arr = value.split(" ");
              // arr.unshift(" ");
              return arr;
            }
          },
          style: {
            colors: "#fff",
          },
          hideOverlappingLabels: false,
          rotate: -45,
          rotateAlways: true,
        },
        title: {
          enabled: true,
          text: " ",
        },
        axisBorder: {
          show: true,
          color: "#fff",
          height: 10,
        },
      },
      yaxis: {
        show: true,
        min: 0,
        max: 4,
        tickAmount: 4,
        labels: {
          align: "right",
          style: {
            colors: "#fff",
          },
          formatter: function (val) {
            return val === 1
              ? ["Unplaced"]
              : val === 2
              ? "Mass"
              : val === 3
              ? "Dream"
              : val === 4
              ? ["Super", "Dream"]
              : "";
          },
          offsetX: 12,
        },
        title: {
          style: {
            color: "#fff",
          },
        },
      },
      grid: {
        show: false,
        borderColor: "#fff",
        position: "back",
        strokeDashArray: 7,
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 30,
          left: 30,
        },
      },
      markers: {
        size: 3,
      },
      tooltip: {
        shared: true,
        intersect: false,
        followCursor: true,
        theme: "dark",
        y: {
          title: {
            formatter: function (val) {
              return val.length >= 0 ? "Your Prep -" : val;
            },
          },
          formatter: function (val) {
            return val === 1
              ? "Unplaced"
              : val === 2
              ? "Mass"
              : val === 4
              ? "Dream"
              : val === 5
              ? "Super Dream"
              : "Close to Dream";
          },
        },
        style: {
          fontSize: "10px",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          colorStops: [
            {
              offset: 0,
              color: "#EB656F",
              opacity: 1,
            },
            {
              offset: 20,
              color: "#FAD375",
              opacity: 1,
            },
            {
              offset: 60,
              color: "#61DBC3",
              opacity: 1,
            },
            {
              offset: 100,
              color: "#95DA74",
              opacity: 1,
            },
          ],
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            chart: {
              height: "200%",
            },
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },
            legend: {
              position: "bottom",
            },
          },
        },
        {
          breakpoint: 600,
          options: {
            chart: {
              height: "200%",
            },
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },
            xaxis: {
              categories: labels,
              labels: {
                rotate: -90,
                rotateAlways: true,
                formatter: function (value) {
                  if (value === "Programming Language") {
                    return "Language  ";
                  }
                  if (value === "Database Management System") {
                    return "DBMS  ";
                  }
                  if (value === "Data Structures") {
                    return "DSA  ";
                  }
                  if (typeof value === "string") {
                    let arr = value.split(" ");
                    if (arr.length === 1) {
                      return arr[0] + "  ";
                    }
                    let str = "";
                    arr.forEach((ele) => {
                      str = str + ele.charAt(0);
                    });
                    return str + "  ";
                  }
                },
              },
            },
          },
        },
      ],
    },
  };
  return <Chart type="line" options={temp.options} series={temp.series} />;
};

export default LineGraph;
